export const ROUTE_AUTH = "route/ROUTE_AUTH";
export const ROUTE_HOME = "route/ROUTE_HOME";
export const ROUTE_MANAGE_CONNECTIONS = 'route/ROUTE_MANAGE_CONNECTIONS';
export const ROUTE_ADVERTISER = "route/ROUTE_ADVERTISER";
export const ROUTE_CAMPAIGN = "route/ROUTE_CAMPAIGN";
export const ROUTE_CAMPAIGN_ERROR_PAGE = 'route/ROUTE_CAMPAIGN_JOB_ERROR';
export const ROUTE_ADVERTISER_TABS = "route/ROUTE_ADVERTISER_TABS";
export const ROUTE_CAMPAIGN_TABS = "route/ROUTE_CAMPAIGN_TABS";
export const ROUTE_EXAMPLE_TAKEOVER = "route/ROUTE_EXAMPLE_TAKEOVER";
export const ROUTE_EXAMPLE_TABS = "route/ROUTE_EXAMPLE_TABS";
export const ROUTE_FORBIDDEN = "route/ROUTE_FORBIDDEN";
export const ROUTE_ADVERTISER_DETAIL = "router/ROUTE_ADVERTISER_DETAIL";
export const ROUTE_CAMPAIGN_DETAIL = "router/ROUTE_CAMPAIGN_DETAIL";
export const ROUTE_CAMPAIGN_EDIT = "router/ROUTE_CAMPAIGN_EDIT";
export const ROUTE_CAMPAIGN_EDIT_TAB = "route/ROUTE_CAMPAIGN_EDIT_TAB";
export const ROUTE_ADVERTISER_EDIT = "router/ROUTE_ADVERTISER_EDIT";
export const ROUTE_GA_INVITE = "router/ROUTE_GA_INVITE";
export const ROUTE_ADMIN_SETTINGS = "route/ROUTE_ADMIN_SETTINGS";
export const ROUTE_NO_PERMISSON = "route/ROUTE_NO_PERMISSION";
export const ROUTE_NO_ADMIN_PERMISSION = "route/ROUTE_NO_ADMIN_PERMISSION";
export const ROUTE_EXPORT_PDF = "route/ROUTE_EXPORT_PDF";
export const ROUTE_EXPORT_CUSTOM_REPORT = "route/ROUTE_EXPORT_CUSTOM_REPORT";
export const ROUTE_ADVERTISER_EDIT_TAB = "route/ROUTE_ADVERTISER_EDIT_TAB";
export const ROUTE_DRILLDOWN = "route/ROUTE_DRILLDOWN";
export const ROUTE_USER_MANAGEMENT = 'route/USER_MANAGEMENT';
export const ROUTE_PLAYOUT_DATA = 'route/PLAYOUT_DATA';
export const ROUTE_PLAYOUT_DATA_MAPPING = 'route/ROUTE_PLAYOUT_DATA_MAPPING';
export const ROUTE_PLAYOUT_UPLOADS = 'route/ROUTE_PLAYOUT_UPLOADS';
export const ROUTE_PLAYOUT_LOADER = 'route/ROUTE_PLAYOUT_LOADER';
export const ROUTE_PLAYOUT_ERROR_REPORT = 'route/ROUTE_PLAYOUT_ERROR_REPORT';
export const ROUTE_PLAYOUT_DRILLDOWN = 'route/ROUTE_PLAYOUT_DRILLDOWN';
export const ROUTE_CREATE_REPORT = 'route/CREATE_REPORT';
export const ROUTE_DEMO_SCHEDULE_REPORT = 'route/DEMO_SCHEDULE_REPORT';
export const ROUTE_CUSTOMIZED_PDF_REPORT = 'route/ROUTE_CUSTOMIZED_PDF_REPORT';
export const ROUTE_UNSUBSCRIBE_REPORT = 'route/ROUTE_UNSUBSCRIBE_REPORT';
export const ROUTE_CUSTOMIZED_PPTX_REPORT = 'route/ROUTE_CUSTOMIZED_PPTX_REPORT';
export const ROUTE_UNSUBSCRIBE_EMAIL = 'route/ROUTE_UNSUBSCRIBE_EMAIL';


export const selectCurrentRoutePayload = state => state.location.payload;
export const selectRouteType = state => state.location.type;
export const selectRoutesMap = state => state.location.routesMap;
export const selectPreviousRoute = state => state.location.prev;

export const PLAYOUT_ROUTES = [
    ROUTE_PLAYOUT_DATA,
    ROUTE_PLAYOUT_DATA_MAPPING,
    ROUTE_PLAYOUT_UPLOADS,
    ROUTE_PLAYOUT_LOADER,
    ROUTE_PLAYOUT_ERROR_REPORT,
    ROUTE_PLAYOUT_DRILLDOWN
];
